import { h } from 'preact';
import { formatDate } from '../../lib/util';
import createDataTable, { tableUtils } from '../cloudquote-data-table';
import { Text } from 'preact-i18n';

const INTL_NS = 'historical-data-panel.headers';

let SplitsDividends = ({ ...props }) => {
	let SplitOrDividend = createDataTable({
		headers: [ <Text id={`${INTL_NS}.date`} />, props.header ],
		cells: [
			tableUtils.formatField('eventDate', formatDate),
			'value'
		]
	});

	return (
		<SplitOrDividend {...props} />
	);
};

export default SplitsDividends;
